export default {
  default: () => import("/home/ia/Desktop/projects/gumbati-nuxt/layouts/default.vue").then(m => m.default || m)
}